import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import DraftsIcon from '@mui/icons-material/Drafts';
import GradingIcon from '@mui/icons-material/Grading';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ReplayIcon from '@mui/icons-material/Replay'; // For Sent_Back
import TelegramIcon from '@mui/icons-material/Telegram';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import {
  Stack,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  Typography
} from "@mui/material";
import { styled } from '@mui/material/styles';
import dayjs from "dayjs";
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import axios from '../../../utils/axios';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // backgroundImage:
      //   'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
      backgroundColor:"#007FFF",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // backgroundImage:
      //   'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
      backgroundColor:"#007FFF",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme,ownerState }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.3s ease',
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.grey[700],
  }),
   ...(ownerState.status === 'Sent_Back' && {
    backgroundColor: '#FFB800', // yellow
    color: '#fff',
  }),
  ...(ownerState.status === 'Bounced' && {
    backgroundColor: '#E53935', // red
    color: '#fff',
  }),
  variants: [
    {
      props: ({ ownerState }) =>  ownerState.active,
      style: {
        // backgroundImage:
        // 'linear-gradient( 136deg, rgba(145, 211, 107, 1) 0%, rgba(139, 194, 189, 1) 50%, rgba(99, 146, 216, 1) 100%)',
          // 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
          backgroundColor: ownerState.status === 'Bounced' ? '#E53935' : ownerState.status === 'Sent_Back' ?  '#FFB800' : ownerState.status === 'Settled' ?  '#00be00ff' : "#007FFF" ,
          color: ownerState.status === 'Sent_Back' ?  '#000000' : "#FFFFFF",
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
      //   backgroundImage:
      //     'linear-gradient( 136deg, rgba(28, 106, 223, 1) 0%, rgba(28, 106, 223, 1) 50%, rgba(28, 106, 223, 1) 100%)',
        backgroundColor:ownerState.status === 'Bounced' ? '#E53935' : ownerState.status === 'Sent_Back' ?  '#FFB800' : ownerState.status === 'Settled' ?  '#00be00ff' : "#007FFF",
        color: ownerState.status === 'Sent_Back' ?  '#000000' : "#FFFFFF",
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className,label } = props;

  const icons = {
    Uploaded: <CloudDoneIcon />,
    Drafted: <DraftsIcon />,
    Initiated: <TelegramIcon /> ,
    Vetted: <HowToRegIcon/>,
    Verified: <WorkspacePremiumIcon/>,
    Audited: <GradingIcon/>,
    Approved: <VerifiedUserIcon/>,
    Transferred: <AssuredWorkloadIcon/>,
    Settled: <VerifiedIcon/>,
    Sent_Back: <ReplayIcon />,
    Bounced: <AutorenewIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active,status:label }} className={className}>
      {icons[label]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  label: PropTypes.string
};



const SettlementWorkFlowTimeline = ({settlementMstId,refreshKey}) => {

  const [timeLineData, setTimeLineData] = useState([]);
  const [dynamicSteps, setDynamicSteps] = useState([]);
  const mainSteps = [ 'Uploaded', 'Drafted','Initiated', 'Vetted', 'Verified', 'Audited', 'Approved','Settled'];
  const [steps, setSteps] = useState([]);
  // reInitializedsteps remains the same
const reInitializedsteps = ['Initiated', 'Vetted', 'Verified', 'Audited', 'Approved', 'Settled'];


  const getTimelineData = async () => {
    try {
      const res = await axios.get(`/settlement-timeline/${settlementMstId}`);
      const data = res.data.payload || [];

      // Sort ascending by createdAt
      const sorted = [...data].sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );

      // Build step list dynamically (including repeated statuses)
      const builtSteps = sorted.map((item) => item.claimStatus);
      if(builtSteps.length === 1 && builtSteps[0] === "Settled" || builtSteps.length === 0)
        {
          setDynamicSteps(mainSteps);
          setSteps(mainSteps);
          setTimeLineData(sorted);
          return;
        }
      setDynamicSteps(builtSteps);
      if(builtSteps[builtSteps.length-1] === "Sent_Back" || builtSteps[builtSteps.length-1] === "Bounced")
      {
        const finalSteps = [];
        finalSteps.push(...builtSteps);
        finalSteps.push(...reInitializedsteps);
          setSteps(finalSteps);
          setTimeLineData(sorted);
          return;
      }
      // if(builtSteps[builtSteps.length-1] === "Bounced")
      // {
      //   const finalSteps = [];
      //   finalSteps.push(...builtSteps);
      //   finalSteps.push(...['Settled']);
      //     setSteps(finalSteps);
      //     setTimeLineData(sorted);
      //     return;
      // }
      

      const lastStatus = builtSteps[builtSteps.length - 1];
      const lastIndex = mainSteps.indexOf(lastStatus);
      const newSteps = lastIndex !== -1 ? mainSteps.slice(lastIndex + 1) : [];
      const finalSteps = [];
      finalSteps.push(...builtSteps);
      finalSteps.push(...newSteps);
      setSteps(finalSteps);
      setTimeLineData(sorted);
      console.log(sorted)
      
      
    } catch (error) {
      console.error("Error fetching timeline", error);
    }
  };

  useEffect(() => {
    getTimelineData();
  }, [settlementMstId,refreshKey]);
  
  return (
    <div>
            <Stack sx={{ width: '100%', maxWidth:"100%",overflowX: "auto", overflowY: "hidden", whiteSpace: "nowrap", }} spacing={4}>
                <Stepper alternativeLabel activeStep={dynamicSteps.length - 1} connector={<ColorlibConnector />} sx={{minWidth:"max-content"}}>
                    {steps.map((status,index) => {
                      const stepData = timeLineData[index];
                      const label = status.replace(/_/g, " ");
                      const stepDataComments = stepData ? stepData?.comments === null ? '' : stepData?.comments : '';

                      return(
                    <Step key={`${status}-${index}`} title={stepData ? `${stepDataComments} By ${stepData.user?.fullName}` : ''}>
                      
              <StepLabel
                StepIconComponent={(props) => (
                  <ColorlibStepIcon {...props} label={status} />
                )}
              >
                
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: "#6a1b9a",
                    textAlign: "center",
                    fontSize: { xs: "0.8rem", sm: "0.9rem" },
                  }}
                >
                  {label} {label ==="Approved" && "(OMC)"}
                </Typography>

                {stepData && (
                  <Stack
                    spacing={0.2}
                    alignItems="center"
                    sx={{
                      mt: 0.5,
                      color: "#555",
                    }}
                  > <Typography
                      variant="caption"
                      sx={{
                        color: "#888",
                      }}
                    >
                      {dayjs(stepData.createdAt).format("DD-MM-YYYY")}
                    </Typography>
                    
                  </Stack>
                )}
              </StepLabel>
            </Step>
                    )})}
                </Stepper>
            </Stack>
    </div>
  )
}

export default SettlementWorkFlowTimeline